import axios from "axios";

const http = axios.create({
    baseURL: process.env.VUE_APP_TMS_SERVER,
    timeout: 30000,
    withCredentials: true
});
http.defaults.headers['Product'] = 'vsp';

http.interceptors.request.use(res => {
    res.headers["token"] = JSON.parse(localStorage.getItem("USER")) ? JSON.parse(localStorage.getItem("USER")).token : '';
    return res;
})

http.interceptors.response.use(
    response => {
        if (response.data.errCode === 1) {
            window.$vm.$Message.error(response.data.errMsg);
            return Promise.reject(response.data);
        }

        return response.data;
    },

    error => {
        window.$vm.$Message.error(error.response.data.errMsg);
        return Promise.reject(error)
    }
);

export default {
    // 获取学校列表
    getSchoolList(param) {
        return http.post('/schoolMgr/getSchoolList', param);
    },
    // 获取学校列表编辑 新建
    schoolMgrUpdateSchool(param) {
        return http.post('/schoolMgr/updateSchool', param);
    },
    // 获取学校列表编辑 新建
    getSchoolInfo(param) {
        return http.get(`/schoolMgr/getSchoolInfo/${param}`);
    },
    // 学校列表删除
    delSchool(schoolId) {
        return http.get(`/schoolMgr/delSchool/${schoolId}`);
    },
    // 获取年级下班级列表
    collegeMgrGetClassList(param) {
        return http.post('/collegeMgr/GetClassList', param);
    },
    // 获取学院列表
    getCollegeList(param) {
        return http.post('/collegeMgr/getCollegeList', param);
    },
    // 获取专业下年级列表
    getGradeList(param) {
        return http.post('/collegeMgr/getGradeList', param);
    },
    // 获取学院下专业列表
    getMajorList(param) {
        return http.post('/collegeMgr/getMajorList', param);
    },
    // 新建编辑学院
    updateCollege(param) {
        return http.post('/collegeMgr/updateCollege', param);
    },
    // 新建编辑专业
    updateMajor(param) {
        return http.post('/collegeMgr/updateMajor', param);
    },
    // ----------------------教师管理-----------------------

    // 获取高校下教师列表
    getTeacherList(param) {
        return http.post('/teacherMgr/getTeacherList', param);
    },
    // 新建 编辑教师信息
    updateTeacher(param) {
        return http.post('/teacherMgr/updateTeacher', param);
    },
    // ----------------------  后台-授课管理 / 客户端-教师授课管理
    // 修改可见班级
    updateCourseWareShareList(param) {
        return http.post('/courseWareMgr/updateCourseWareShareList', param);
    },
    // 获取课件分享的课程状态
    getCourseWareShareList(param) {
        return http.get(`/courseWareMgr/getCourseWareShareList/${param.schoolId}/${param.courseWareId}`);
    },
    // 获取教师信息
    getTeacherInfo(param) {
        return http.get(`/teacherMgr/getTeacherInfo/${param.schoolId}/${param.teacherId}`);
    },
    //  获取讲师的授课列表
    getCourseList(param) {
        return http.post('/courseMgr/getCourseList', param);
    },
    // 查询上课学生班级
    getSchoolClass(param) {
        return http.post('/courseMgr/getSchoolClass', param);
    },

    // 编辑 新建授课班级
    updateCourse(param) {
        return http.post('/courseMgr/updateCourse', param);
    },

    // 获取 课程表
    getCourseSection(param) {
        return http.get(`/courseMgr/getCourseSection/${param.schoolId}/${param.courseId}`);
    },
    // 设置 课程表
    setCourseSection(param) {
        return http.post('/courseMgr/setCourseSection', param);
    },
    // 清空所有已添加
    clearCourseSection(param) {
        return http.get(`/courseMgr/clearCourseSection/${param.schoolId}/${param.courseId}`);
    },

    // 课程表删除小节
    delCourseSection(param) {
        return http.get(`/courseMgr/delCourseSection/${param.schoolId}/${param.sectionId}`);
    },

    // 获取授课列表
    getCourseSummaryList(param) {
        return http.post(`/courseMgr/getCourseSummaryList`, param);
    },
    // 获取教师的课件列表
    getCourseWareList(param) {
        return http.post('/courseWareMgr/getCourseWareList', param);
    },
    // 删除课件
    delCourseWare(param) {
        return http.post('/courseWareMgr/delCourseWare', param);
    },
    getCourseWareAttachmentList(param) {
        return http.post(`/courseWareMgr/getCourseWareAttachmentList/${param.schoolId}/${param.courseWareId}`);
    },

    // 获取课件附件列表
    // ----------------------  学生管理---------------------

    // 新建 编辑学生信息
    updateStudent(param) {
        return http.post('/studentMgr/updateStudent', param);
    },
    // 获取高校下学生列表 - 讲师客户端-学生管理
    getStudentList(param) {
        return http.post('/studentMgr/getStudentList', param);
    },
    // 删除学生信息
    delStudent(param) {
        return http.get(`/studentMgr/delStudent/${param.schoolId}/${param.studentId}`);
    },
    // 获取学生信息
    getStudentInfo(param) {
        return http.get(`/studentMgr/getStudentInfo/${param.schoolId}/${param.studentId}`);
    },

    // 新建编辑公告
    updateAnnounce(param) {
        return http.post('/announce/updateAnnounce', param);
    },
    // 公告列表
    queryAnnounceList(param) {
        return http.post('/announce/queryAnnounceList', param);
    },
    // 获取公告对授课班级可见状态
    getAnnounceVisibleList(param) {
        return http.get(`/announce/getAnnounceVisibleList/${param.schoolId}/${param.courseWareId}`);
    },

    // 修改公告可见班级
    updateAnnounceVisible(param) {
        return http.post('/announce/updateAnnounceVisible', param);
    },
    // -------------教师作业--------------------
    // 随机生成-预先查看分组情况
    previewGroup(param) {
        return http.post('/courseWorkMgr/previewGroup', param);
    },
    // 删除公告
    delAnnounce(param) {
        return http.get(`/announce/delAnnounce/${param.schoolId}/${param.announceId}`);
    },
    // 上传课件
    uploadCourseWare(param) {
        return http.post('/courseWareMgr/uploadCourseWare', param);
    },

    // 针对课程创建分组
    creatCourseGroup(param) {
        return http.post('/courseWorkMgr/creatCourseGroup', param);
    },
    // 获取授课课程已有分组配置列表
    getCourseGroup(param) {
        return http.get(`/courseWorkMgr/getCourseGroup/${param.schoolId}/${param.courseId}`);
    },
    // 新建编辑作业
    updateCourseWork(param) {
        return http.post('/courseWorkMgr/updateCourseWork', param);
    },
    // 获取作业列表
    queryCourseWorkList(param) {
        return http.post('/courseWorkMgr/queryCourseWorkList', param);
    },
    // 删除作业
    delCourseWork(param) {
        return http.get(`/courseWorkMgr/delCourseWork/${param.schoolId}/${param.workId}`);
    },

    // 获取作业详情
    getCourseWorkInfo(param) {
        return http.get(`/courseWorkMgr/getCourseWorkInfo/${param.schoolId}/${param.workId}`);
    },

    // 新建编辑年级
    updateGrade(param) {
        return http.post('/collegeMgr/updateGrade', param);
    },

    // 新建编辑班级
    updateClass(param) {
        return http.post('/collegeMgr/updateClass', param);
    },
    // 删除讲师
    delTeacher(param) {
        return http.get(`/teacherMgr/delTeacher/${param.schoolId}/${param.teacherId}`);
    },
    // 删除班级
    delClass(param) {
        return http.post('/collegeMgr/delClass', param);
    },
    // 删除学院
    delCollege(param) {
        return http.post('/collegeMgr/delCollege', param);
    },
    // 删除年级
    delGrade(param) {
        return http.post('/collegeMgr/delGrade', param);
    },
    // 删除专业
    delMajor(param) {
        return http.post('/collegeMgr/delMajor', param);
    },
    // 获取授课班级下的班级列表
    getCourseTeachingClass(param) {
        return http.get(`/courseMgr/getCourseTeachingClass/${param.schoolId}/${param.courseId}`);
    },
    // 删除 授课班级
    delCourse(param) {
        return http.get(`/courseMgr/delCourse/${param.schoolId}/${param.courseId}`);
    },

    // 获取作业完成情况
    queryWorkFinishStatus(param) {
        return http.post('/courseWorkMgr/queryWorkFinishStatus', param);
    },
    // 获取作业完成详情
    getWorkFinishInfo(param) {
        return http.get(`/courseWorkMgr/getWorkFinishInfo/${param.schoolId}/${param.studentWorkId}`);
    },

    // 自动评分
    automaticGrading(param) {
        return http.get(`/courseWorkMgr/automaticGrading/${param.schoolId}/${param.studentWorkId}`);
    },
    // 批改学生作业
    correctStudentWork(param) {
        return http.post('/courseWorkMgr/correctStudentWork', param);
    },
    // 公布成绩
    publishWorkScore(param) {
        return http.get(`/courseWorkMgr/publishWorkScore/${param.schoolId}/${param.workId}`);
    },

    // 获取课程已有组的成员情况
    getCourseGroupMember(param) {
        return http.get(`/courseWorkMgr/getCourseGroupMember/${param.schoolId}/${param.workGroupId}`);
    },
    // 下发作业
    publishCourseWork(param) {
        return http.get(`/courseWorkMgr/publishCourseWork/${param.schoolId}/${param.workId}`);
    },

    // 请求文件夹列表
    getFileInfoList(data) {
        return https.post(`${serveFiles}/getFileInfoList`, data);
    },
    // 获取文件元信息
    getFileInfoByIds(listIds) {
        return https.post(`${serveFiles}/getFileInfoByIds`, {
            listIds,
        });
    },

    // // 获取当前用户私有池
    // getUserStrategyPool(data) {
    //     return http.post(`${serveSupport}/atStrategy/getUserStrategyPool`, data);
    // },
    // // ----------------AT策略详情----------------
    // // 获取用户下策略详情
    // getUstSTPerformance(param) {
    //     return http.get(`${serveSupport}/atStrategy/getUstSTPerformance/${param.userId}/${param.strategyId}`);
    // },
    // // 获取策略详情
    // getStrategyInfo(strategyId) {
    //     return http.get(`${serveSupport}/atStrategy/getStrategyInfo/${strategyId}`);
    // },
    // // 
    // // 获取策略代码
    // getSTCode(param) {
    //     return http.get(`${serveSupport}/atStrategy/getSTCode/${param.userId}/${param.strategyId}/${param.fileName}`);
    // },

    // 获取新增学生excel模板
    downloadTemplateExcel() {
        return http.get(`/studentMgr/downloadTemplateExcel`, {
            responseType: 'arraybuffer',
        });
    },
    // 批量绑定学生
    uploadStudent(param, formData) {
        return http.post(`/studentMgr/uploadStudent/${param.schoolId}/${param.collegeId}/${param.majorId}/${param.gradeId}/${param.classId}`, formData);
    },

    // 批量绑定教师
    uploadTeacher(param, formData) {
        return http.post(`/teacherMgr/uploadTeacher/${param.schoolId}/${param.collegeId}`, formData);
    },
    // 获取新增教师excel模板
    teacherMgrExcel() {
        return http.get(`/teacherMgr/downloadTemplateExcel`, {
            responseType: 'arraybuffer',
        });
    },


    // 课程下载模板excel
    courseMgrExcel() {
        return http.get(`/courseMgr/downloadTemplateExcel`, {
            responseType: 'arraybuffer',
        });
    },
    // 上传课程小节
    uploadCourseSection(param, formData) {
        return http.post(`/courseMgr/uploadCourseSection/${param.schoolId}/${param.teacherId}/${param.courseId}`, formData);
    },
    // // 下载策略代码
    // downloadSTCode(param) {
    //     return http.get(`${serveSupport}/atStrategy/downloadSTCode/${param.userId}/${param.strategyId}/${param.fileName}`);
    // },
};